module.exports = __webpack_public_path__ + "fonts/Barlow-Black.e8ce2d7d.ttf";